var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { delegateEvent } from './utils';
export function fetchAvailableDates(instance, expertId, rootEl) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const expertState = instance.stateManager.getExpertState(expertId);
        const year = expertState.currentDate.getFullYear();
        const monthNum = String(expertState.currentDate.getMonth() + 1).padStart(2, '0');
        const month = `${year}-${monthNum}`;
        // Cancel previous request and guard against stale responses
        try {
            (_a = expertState._datesController) === null || _a === void 0 ? void 0 : _a.abort();
        }
        catch (_) { }
        const controller = new AbortController();
        expertState._datesController = controller;
        const reqId = (expertState._datesReqId || 0) + 1;
        expertState._datesReqId = reqId;
        try {
            const response = yield fetch(`/wp-json/book-a-call/v1/available-dates?expert_id=${expertId}&month=${month}&timezone=${expertState.timezone}`, { signal: controller.signal });
            if (!response.ok) {
                throw new Error(`API returned ${response.status}`);
            }
            const data = yield response.json();
            if (reqId !== expertState._datesReqId)
                return; // Ignore stale
            expertState.availableDates = data.dates || [];
        }
        catch (err) {
            if ((err === null || err === void 0 ? void 0 : err.name) === 'AbortError')
                return;
            console.error('Failed to fetch available dates:', err);
            expertState.availableDates = [];
            const calendarContainer = (rootEl ? rootEl.querySelector(`#booking-calendar-${expertId}`) : null) || document.getElementById(`booking-calendar-${expertId}`);
            if (calendarContainer) {
                const errorMsg = ((_b = window.cgBookACallI18n) === null || _b === void 0 ? void 0 : _b.backendRequired) || 'Booking service is currently unavailable. Please try again later.';
                calendarContainer.innerHTML = `<div class="calendar-error" style="padding: 20px; text-align: center; color: #d32f2f;">${errorMsg}</div>`;
            }
        }
    });
}
export function isDateAvailable(instance, dateStr, expertId) {
    const expertState = instance.stateManager.getExpertState(expertId);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const date = new Date(dateStr + 'T00:00:00');
    if (date < today)
        return false;
    if (!expertState.availableDates || expertState.availableDates.length === 0)
        return false;
    return expertState.availableDates.includes(dateStr);
}
export function renderCalendar(instance, expertId, date, rootEl) {
    const calendarContainer = (rootEl ? rootEl.querySelector(`#booking-calendar-${expertId}`) : null) || document.getElementById(`booking-calendar-${expertId}`);
    if (!calendarContainer)
        return;
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDay.getDay());
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const daysHTML = renderCalendarDays(instance, expertId, startDate, year, month);
    const calendarHTML = `
        <div class="calendar-wrapper">
        <div class="calendar-header">
            <button type="button" class="nav-btn nav-prev prev-month" data-direction="-1" data-expert-id="${expertId}">
                <i class="ti ti-chevron-left"></i>
            </button>
            <div class="month-year">${monthNames[month]} ${year}</div>
            <button type="button" class="nav-btn nav-next next-month" data-direction="1" data-expert-id="${expertId}">
                <i class="ti ti-chevron-right"></i>
            </button>
        </div>
        <div class="calendar-grid">
            <div class="day-header">Sun</div>
            <div class="day-header">Mon</div>
            <div class="day-header">Tue</div>
            <div class="day-header">Wed</div>
            <div class="day-header">Thu</div>
            <div class="day-header">Fri</div>
            <div class="day-header">Sat</div>
            ${daysHTML}
        </div>
        </div>
    `;
    calendarContainer.innerHTML = calendarHTML;
    calendarContainer.classList.add('loaded');
    if (!calendarContainer.dataset.bound) {
        delegateEvent(calendarContainer, 'click', '.nav-btn', (e, target) => {
            const direction = parseInt(target.dataset.direction);
            const targetExpertId = parseInt(target.dataset.expertId);
            const state = instance.stateManager.getExpertState(targetExpertId);
            const year = state.currentDate.getFullYear();
            const month = state.currentDate.getMonth();
            state.currentDate = new Date(year, month + direction, 1);
            fetchAvailableDates(instance, targetExpertId, rootEl).then(() => {
                renderCalendar(instance, targetExpertId, state.currentDate, rootEl);
            });
        });
        delegateEvent(calendarContainer, 'click', '.calendar-day[data-selectable="true"]', (e, target) => {
            const ds = target.dataset.date;
            const eid = parseInt(target.dataset.expertId);
            instance.selectDate(eid, ds, rootEl);
        });
        delegateEvent(calendarContainer, 'keydown', '.calendar-day[data-selectable="true"]', (e, target) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const ds = target.dataset.date;
                const eid = parseInt(target.dataset.expertId);
                instance.selectDate(eid, ds, rootEl);
            }
        });
        calendarContainer.dataset.bound = 'true';
    }
}
export function renderCalendarDays(instance, expertId, startDate, currentYear, currentMonth) {
    var _a;
    let daysHTML = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const loopDate = new Date(startDate);
    const expertState = instance.stateManager.getExpertState(expertId);
    const selectedDateStr = expertState.date || null;
    for (let i = 0; i < 42; i++) {
        const year = loopDate.getFullYear();
        const month = String(loopDate.getMonth() + 1).padStart(2, '0');
        const day = String(loopDate.getDate()).padStart(2, '0');
        const dateStr = `${year}-${month}-${day}`;
        const isCurrentMonth = loopDate.getMonth() === currentMonth;
        const isToday = loopDate.toDateString() === today.toDateString();
        const isSelected = selectedDateStr === dateStr;
        const isPast = loopDate < today && !isToday;
        const isAvailable = isDateAvailable(instance, dateStr, expertId);
        let classes = ['calendar-day'];
        if (!isCurrentMonth)
            classes.push('other-month');
        if (isAvailable && !isPast)
            classes.push('available');
        if (isSelected)
            classes.push('selected');
        if (isPast || !isAvailable)
            classes.push('unavailable');
        daysHTML += `
            <div class="${classes.join(' ')}" 
                 data-date="${dateStr}"
                 data-expert-id="${expertId}"
                 ${isAvailable && !isPast ? 'data-selectable="true" tabindex="0" role="button" aria-label="' + (((_a = window.cgBookACallI18n) === null || _a === void 0 ? void 0 : _a.select) || 'Select') + ' ' + dateStr + '"' : ''}>
                <span>${loopDate.getDate()}</span>
            </div>
        `;
        loopDate.setDate(loopDate.getDate() + 1);
    }
    return daysHTML;
}
